// @ts-nocheck
/* eslint-disable */
export const checkIcon = {
    data: `<svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.86339 11.524L3.08339 8.74404L2.13672 9.68404L5.86339 13.4107L13.8634 5.4107L12.9234 4.4707L5.86339 11.524Z" fill="currentColor"/></svg>`,
    name: 'check' as const
};